import React from "react";
import { Link } from "react-router-dom";

export const ItemsSlider = ({ link, img, name, amount, id }) => {
    return (
        <Link to={link} className="glide__slide sliderPlanes--li">
            <img src={`/storage/modelos/${id}/${img}`} />
            <h1>{name}</h1>
            <p>
                Cuota desde <strong>${amount}</strong>{" "}
            </p>
            <button className="btn-sliderPlanes">Conocer más</button>
        </Link>
    );
};
